export default {
  "metrics_setting_title": "Metrics Settings",
  "metrics_setting_show_metrics": "Show Metrics",
  "metrics_setting_show_more_statistics": "Show More Statistics",
  "metrics_setting_show_more_statistics_tips": "The statistical values will be displayed at the end of the table.",
}
